import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { PromptSuggestionDto, PromptSuggestionExampleDto } from '@app/data/dto';
import { AppIcon } from '@app/shared/controls/app-icon/app-icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-prompt-suggestion',
  imports: [AppIcon, CommonModule, TranslatePipe],
  templateUrl: './prompt-suggestion.html',
  styleUrl: './prompt-suggestion.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptSuggestion {
  readonly suggestions = input<readonly PromptSuggestionDto[]>([]);
  readonly loading = input(false);
  readonly closed = output<void>();
  readonly refreshed = output<void>();
  readonly exampleSelected = output<PromptSuggestionExampleDto>();

  protected readonly selectedSuggestion = signal<PromptSuggestionDto | null>(null);
  protected readonly explanationLines = computed(() => this.selectedSuggestion()?.explaination.message
    .split('\n')
    .map((line) => line.trim().replace(/^[-*]\s*/, ''))
    .filter(Boolean) ?? []);

  protected selectSuggestion(suggestion: PromptSuggestionDto): void {
    this.selectedSuggestion.set(suggestion);
  }

  protected goBack(): void {
    this.selectedSuggestion.set(null);
  }
}
